import type { PhotoSize } from '../domain/bulkSelection';

/**
 * Read a picked file as a photo, for its size: the web's "copy" of a photo
 * into the page (021 R7). Rejects when the file isn't a readable image.
 */
export async function readPhotoSize(file: File): Promise<PhotoSize> {
  if (typeof createImageBitmap === 'function') {
    const bitmap = await createImageBitmap(file);
    const size = { width: bitmap.width, height: bitmap.height };
    bitmap.close();
    return size;
  }
  const url = URL.createObjectURL(file);
  try {
    const image = new Image();
    image.src = url;
    await image.decode();
    return { width: image.naturalWidth, height: image.naturalHeight };
  } finally {
    URL.revokeObjectURL(url);
  }
}
